import { NgModule } from '@angular/core';
import { PreChatComponent } from './pre-chat.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModule } from '../app-material.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
      PreChatComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    SharedModule,
  ],
  entryComponents: [PreChatComponent],
  providers: [
    { provide: 'components', useValue: [PreChatComponent], multi: true }
  ],
})
export class PreChatAppModule {
  constructor(){
    let options = {
      failed: !!model.error,
      language: model.userLanguage,
      isPreChatForm: true,
      displaySettingId:  model.displaySettingId,
      offlineTimeout: parseInt(model.customerTimeout) * 1000,  
    };
    var prechat = new PreChat(options);
    prechat.init();
  }
}